import dayjs from "dayjs";
import ImageWithBasePath from "../../../../../../core/common/imageWithBasePath";
import { useEffect } from "react";

const MultiplePagePdfPowerOfAttorney = ({ printRef, printOutPdfDetails,onRenderReady }: any) => {


    const formatDate = (date: Date | string) => {
        return dayjs(date).format("MMM-D-YYYY").toUpperCase();
    };
    const formattedDate = formatDate(new Date());
    useEffect(() => {
        if (printOutPdfDetails) {
            onRenderReady?.();
        }
    }, [printOutPdfDetails]);

    return (
        <div className="p-3">
            <div ref={printRef} className="d-flex flex-column gap-4" id="21">
                {/* Page 1 */}
                <div className="position-relative" style={{ height: "270mm", backgroundColor: "#fff", padding: "2rem", overflow: "hidden",pageBreakAfter: "always" }}>
                    <header className="w-100 py-3 f-f text-center">
                        <div className="row mb-6 justify-content-between align-items-center">
                            <div className='col-md-6' style={{ flex: '0 0 50%', maxWidth: '50%' }} >
                                <div className='d-flex align-items-center justify-content-center text-center'>
                                    <ImageWithBasePath
                                        src={'assets/img/logo.svg'}
                                        className=""
                                        alt="Logo"
                                        width={300}
                                        height={68}
                                    />
                                </div>
                            </div>
                            <div className='col-md-6 d-flex flex-column justify-content-center align-items-center' style={{ flex: '0 0 50%', maxWidth: '50%' }}>
                                <div className="" style={{ textAlign: 'justify' }}>
                                    <div className='d-flex mb-2 f-f fs-16'>
                                        <p className="text-sm w-20 mb-0 ">Buyer's Name:</p>
                                        <p className="text-sm mb-0">{printOutPdfDetails?.result?.primaryContactFirstName + " " + printOutPdfDetails?.result?.primaryContactLastName}
                                        </p>
                                    </div>
                                    <div className='d-flex mb-2 f-f fs-16'>
                                        <p className="text-sm w-20 mb-0">Address:</p>
                                        <p className="text-sm  mb-0">{printOutPdfDetails?.result?.propertyAddressLine1}
                                        </p>
                                    </div>
                                    <div className='d-flex mb-2 f-f fs-16'>
                                        <p className="text-sm w-20 mb-0">City, State, ZIP:</p>
                                        <p className="text-sm  mb-0">{
                                            `${printOutPdfDetails?.result?.propertyCity || ''}${printOutPdfDetails?.result?.propertyCity ? ', ' : ''}${printOutPdfDetails?.result?.propertyState || ''}${printOutPdfDetails?.result?.propertyState ? ', ' : ''}${printOutPdfDetails?.result?.propertyZipCode || ''}`
                                        }</p>
                                    </div>
                                    <div className='d-flex mb-2 f-f fs-16'>
                                        <p className="text-sm w-20 mb-0">Project#: </p>
                                        <p className="text-sm  mb-0">{printOutPdfDetails?.result?.projectNumber}</p>
                                    </div>
                                    <div className='d-flex mb-2 f-f fs-16'>
                                        <p className="text-sm w-20 mb-0">Date: </p>
                                        <p className="text-sm  mb-0">{formattedDate}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </header>
                    <main className="mt-2 mb-1 py-2 text-center f-f">
                        <h4 className="text-center font-bold  mb-4 mt-3 fs-19 f-f">Power of Attorney</h4>
                        <div style={{ textAlign: 'justify' }}>
                            <div className="">WHEREAS, Airoom, LLC. (“Airoom”) entered into a Cash Sales Contract for custom construction and remodeling at the address shown above with (herein sometimes referred to individually as the “Buyer” and collectively as the “Buyers”).</div>

                            <div className="mt-1 mb-1">NOW, THEREFORE, Buyers agree as follows (strike out whichever paragraph does not apply):</div>
                            <ul>
                                <li className="ms-4">• Buyers hereby appoint each other, individually, and without the consent of the other, to make, agree
                                    to, and sign off on, any and all change orders, decisions, recommendations and/or Selections
                                    (as that term is defined in the “Contract”), in connection with the Contract. Buyers agree and
                                    acknowledge that Airoom may rely on and act upon the decision of either Buyer, as being the
                                    decision of both Buyers, without obtaining the written or oral consent of both Buyers. The signature
                                    of one Buyer on any change order or other document in connection with this Contract shall be
                                    deemed the decision of both Buyers. Airoom shall incur no liability to either Buyer when acting
                                    upon the consent of one Buyer.</li>
                            </ul>
                            OR;
                            <ul>
                                <li className="ms-4">• Buyers hereby appoint (the “Designer”) to make, agree to, and sign off on, any and all change
                                    orders, decisions, recommendations and/or Selections (as that term is defined in the “Contract”),
                                    in connection with the Contract, without either Buyer’s or both Buyers’ consent. Buyers agree
                                    and acknowledge that Airoom may rely on and act upon the decision of the Designer, as being the
                                    decision of both Buyers, without obtaining the written or oral consent of either or both Buyers. The
                                    signature of the Designer on any change order or other document in connection with this Contract
                                    shall be deemed the decision of both Buyers. Airoom shall incur no liability to either Buyer when
                                    acting upon the consent of the Designer.</li>
                            </ul>
                            <div className="mt-1"> ALSO (strike out whichever paragraph does not apply);
                            </div>
                            <ul className="ms-4 mt-1">
                                <li>• This Authorization shall not be effected by either Buyer’s incapacity, and shall continue in effect,
                                    until written notice of its revocation, signed by both Buyers, is received by Airoom, at Airoom’s
                                    offices at 6825 N. Lincoln Avenue, Lincolnwood, Illinois 60712, to the Attention of Seymour Turner.
                                    Anyone at Airoom dealing with one Buyer or the Designer, shall be protected in relying upon the
                                    authority granted in this Authorization, in the absence of actual knowledge to the contrary.</li>
                                <li>• This Authorization shall be binding upon the Buyers, their heirs, successors, and assigns.</li>
                                <li>• Buyers hereby state, acknowledge and agree that they are fully informed as to the contents of
                                    this Authorization and understand the full import of this grant of powers to each other or to the
                                    Designer, as the case may be.</li>
                            </ul>

                        </div>
                    </main>
                    <footer className="position-absolute bottom-0 w-100 py-2 text-center">
                        <hr className="border-gray-300 bottom-0 my-4" />
                        <p className='text-center fs-10 f-f fw-600'>DESIGN & BUILD SHOWROOM | 6825 N. LINCOLN AVE., LINCOLNWOOD IL 60712 | 847-485-1763
                            <br />
                            DESIGN STUDIO | 36 S. WASHINGTON ST., HINSDALE IL 60521 | 630-280-3380
                            <a href='https://Airoom.com'> Airoom.com</a>
                        </p>
                    </footer>
                </div>

                {/* Page 2 */}
                <div className="position-relative" style={{ height: "270mm", backgroundColor: "#fff", padding: "2rem", overflow: "hidden",pageBreakAfter: "always"}}>
                    <header className="w-100 py-3 text-center">
                        <div className="row mb-6 justify-content-between align-items-center">
                            <div className='col-md-6' style={{ flex: '0 0 50%', maxWidth: '50%' }}>
                                <div className='d-flex align-items-center justify-content-center text-center'>
                                    <ImageWithBasePath
                                        src={'assets/img/logo.svg'}
                                        className=""
                                        alt="Logo"
                                        width={300}
                                        height={68}
                                    />
                                </div>
                            </div>
                            <div className='col-md-6 d-flex flex-column justify-content-center align-items-center' style={{ flex: '0 0 50%', maxWidth: '50%' }}>
                                <div className="" style={{ textAlign: 'justify' }}>
                                    <div className='d-flex mb-2 f-f fs-16'>
                                        <p className="text-sm w-20 mb-0 ">Buyer's Name:</p>
                                        <p className="text-sm mb-0">{printOutPdfDetails?.result?.primaryContactFirstName + " " + printOutPdfDetails?.result?.primaryContactLastName}
                                        </p>
                                    </div>
                                    <div className='d-flex mb-2 f-f fs-16'>
                                        <p className="text-sm w-20 mb-0">Address:</p>
                                        <p className="text-sm  mb-0">{printOutPdfDetails?.result?.propertyAddressLine1}
                                        </p>
                                    </div>
                                    <div className='d-flex mb-2 f-f fs-16'>
                                        <p className="text-sm w-20 mb-0">City, State, ZIP:</p>
                                        <p className="text-sm  mb-0">{
                                            `${printOutPdfDetails?.result?.propertyCity || ''}${printOutPdfDetails?.result?.propertyCity ? ', ' : ''}${printOutPdfDetails?.result?.propertyState || ''}${printOutPdfDetails?.result?.propertyState ? ', ' : ''}${printOutPdfDetails?.result?.propertyZipCode || ''}`
                                        }</p>
                                    </div>
                                    <div className='d-flex mb-2 f-f fs-16'>
                                        <p className="text-sm w-20 mb-0">Project#: </p>
                                        <p className="text-sm  mb-0">{printOutPdfDetails?.result?.projectNumber}</p>
                                    </div>
                                    {/* <div className='d-flex mb-2 f-f fs-16'>
                                        <p className="text-sm w-20 mb-0">Date: </p>
                                        <p className="text-sm  mb-0">{formattedDate}</p>
                                    </div> */}
                                </div>
                            </div>
                        </div>

                    </header>
                    <main className="mt-2 mb-1 py-2 text-center f-f">
                        <h4 className="text-center font-bold  mb-4 mt-3 fs-19 f-f">Power of Attorney Authorization</h4></main>
                    <div>
                        IN WITNESS WHEREOF, Buyers have hereunto set their hand and seal to this:
                        <div className="mt-4 mb-4 d-flex justify-content-around">
                            <p>
                                Witness Signature: _______________________  </p>
                            <div className="d-flex">Name:&nbsp;<div className="text-center"><p className="mb-0">  ________________________ </p><p className="text-gray fs-11 f-f"><i>{"[PRINTED]"}</i></p></div></div>
                            <p> Date: {formattedDate}</p>
                        </div>
                        <div className="mt-4 mb-4 d-flex justify-content-around">
                            <p>
                                Witness Signature: _______________________ </p>
                            <div className="d-flex">Name:&nbsp; <div className="text-center"><p className="mb-0">  ________________________ </p><p className="text-gray fs-11 f-f"><i>{"[PRINTED]"}</i></p></div></div>
                            <p>Date: {formattedDate}</p>
                        </div>
                        <h4 className="text-center font-bold  mb-4 mt-3 fs-19 f-f"> Acknowledgement & Consent</h4>
                        <p className="mb-3"> The Designer hereby acknowledges and consents to the grant of authority given him or her pursuant to
                            this Authorization.
                        </p>
                        <p>
                            IN WITNESS WHEREOF, the Designer has hereunto set his or her hand and seal to this Acknowledgement
                            and Consent:</p>
                        <div className="mt-5 d-flex justify-content-around">
                            <p>
                                Airoom Designer: _________________________
                            </p>
                            <p>
                                Date: {formattedDate}
                            </p>
                        </div>
                        <h4 className="text-center font-bold  mb-4 mt-3 fs-19 f-f"> Acknowledgement of Receipt</h4>
                        <p className="mb-3">  Airoom hereby acknowledges Receipt of this Authorization:
                        </p>
                        <div className="mt-5 d-flex justify-content-around">
                            <p>
                                Airoom Rep: __________________________
                            </p>
                            <p>
                                Date: {formattedDate}
                            </p>
                        </div>
                        <div className="mt-5 d-flex justify-content-around">
                            <p>
                                Airoom Rep Title: _____________________
                            </p>
                            <p>
                                Date: {formattedDate}
                            </p>
                        </div>
                    </div>
                    <footer className="position-absolute bottom-0 w-100 py-2 text-center">
                        <hr className="border-gray-300 bottom-0 my-4 mt-5" />
                        <p className='text-center fs-10 f-f fw-600'>DESIGN & BUILD SHOWROOM | 6825 N. LINCOLN AVE., LINCOLNWOOD IL 60712 | 847-485-1763
                            <br />
                            DESIGN STUDIO | 36 S. WASHINGTON ST., HINSDALE IL 60521 | 630-280-3380
                            <a href='https://Airoom.com'> Airoom.com</a>
                        </p>
                    </footer>
                </div>
            </div>
        </div>

    );
};

export default MultiplePagePdfPowerOfAttorney;
